// extracted by mini-css-extract-plugin
export default {"base":"vp_vEv9l","check":"vp_G7GBZ","icon":"vp_eYK4U","label":"vp_zgWFq","noMargin":"vp_KPvaX","isChecked":"vp_PcQSx","isDisabled":"vp_iby2Z","rightToLeft":"vp_Fxj6O"};